
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-pejabat-penilai-kinerja/penilai/penetapan",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-pejabat-penilai-kinerja/penilai/penetapan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-pejabat-penilai-kinerja/penilai/penetapan"])
      });
    }
  